import { render, staticRenderFns } from "./ClinicianTypeMatchQuestion.vue?vue&type=template&id=8a18bb08"
import script from "./ClinicianTypeMatchQuestion.vue?vue&type=script&lang=js"
export * from "./ClinicianTypeMatchQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports